.editorBody {
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-4);
  margin-top: var(--hcr-spacing-4);
}

.headerContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.headerIcons {
  display: flex;
  gap: var(--hcr-spacing-2);
  margin-right: var(--hcr-spacing-2);
}

.footer {
  border-top: 1px solid var(--hcr-line-primary-color);
}
